import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { AuthService } from "src/app/service/auth.service";

@Component({
    selector: "app-no-institutes-modal",
    templateUrl: "./no-institutes-popup.component.html",
    styleUrls: ["./no-institutes-popup.component.scss"]
})

export class NoInstitutesFoundModalComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<NoInstitutesFoundModalComponent>,
        private authService: AuthService
    ) {}

    ngOnInit(): void {
        this.dialogRef.disableClose = true;
    }

    close(): void {
        this.dialogRef.close();
        this.authService.logout();
    }
}